import { render } from "./cascader.md?vue&type=template&id=1ee036b7"
import script from "./cascader.md?vue&type=script&lang=js"
export * from "./cascader.md?vue&type=script&lang=js"
script.render = render

export default script